module.exports = __webpack_public_path__ + "img/avatar.53d62167.svg";